// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum NoteProp {
	CreatedBy = 'createdBy',
	CreationTime = 'creationTime',
	Description = 'description',
	EntityId = 'entityId',
	EntityType = 'entityType',
	Favorite = 'favorite',
	Id = 'id',
	SectionName = 'sectionName'
}

export type NotePropCreatedBy = {
	[NoteProp.CreatedBy] : models.UserDto
}
export type NotePropCreationTime = {
	[NoteProp.CreationTime] : number | null
}
export type NotePropDescription = {
	[NoteProp.Description] : string | null
}
export type NotePropEntityId = {
	[NoteProp.EntityId] : number | null
}
export type NotePropEntityType = {
	[NoteProp.EntityType] : string | null
}
export type NotePropFavorite = {
	[NoteProp.Favorite] : boolean | null
}
export type NotePropId = {
	[NoteProp.Id] : number
}
export type NotePropSectionName = {
	[NoteProp.SectionName] : string | null
}


export type Note = 
	NotePropCreatedBy & 
	NotePropCreationTime & 
	NotePropDescription & 
	NotePropEntityId & 
	NotePropEntityType & 
	NotePropFavorite & 
	NotePropId & 
	NotePropSectionName

export const NOTE_PROPERTY_NAMES = Object.freeze([NoteProp.CreatedBy, NoteProp.CreationTime, NoteProp.Description, NoteProp.EntityId, NoteProp.EntityType, NoteProp.Favorite, NoteProp.Id, NoteProp.SectionName])

export type Notes = 
	NotePropId & 
	NotePropEntityId & 
	NotePropEntityType & 
	NotePropSectionName & 
	NotePropDescription & 
	NotePropFavorite & 
	NotePropCreatedBy & 
	NotePropCreationTime

export const NOTES_PROPERTY_NAMES = Object.freeze([NoteProp.Id, NoteProp.EntityId, NoteProp.EntityType, NoteProp.SectionName, NoteProp.Description, NoteProp.Favorite, NoteProp.CreatedBy, NoteProp.CreationTime])
